<ui-card-page>
	<ng-container modal-header>
		<div style="margin-top: 20%;" class="resume_header">
			<div class="resume_header__images">
				<img [src]="'assets/images/ibk-logo.svg' | locationAssets" style="width: 250px" alt="ibk"/>
			</div>
			<div class="resume_header__images">
				<img style="width: 98px;" [src]="'assets/images/ibk-icon-ok.png' | locationAssets" alt="ibk"/>
			</div>
		</div>
	</ng-container>
	<ng-container modal-subtitle>
		<div style="margin: 18px;" class="resume_header__title">{{ this.prp.form_data.title }}</div>
	</ng-container>
	<ng-container modal-body>
		<div class="resumen_body">
			<div class="resumen_body">
				<table style="width: 100%;">
					<tr>
						<th colspan="2">
							<hr style="height: 1px; background-color: #cccccc; border: none; margin-bottom: 16px;">
						</th>
					</tr>
					<tr>
						<td style="width: 60%;"><span
							class="resumen_item__title">{{ this.prp.transfer_data.title }}</span></td>
						<td style="width: 40%;"><span
							class="resumen_item__detail">{{ this.prp.transfer_data.operation }}</span></td>
					</tr>
					<tr>
						<td style="width: 60%;"><span
							class="resumen_item__title">{{ this.prp.transfer_amount.title }}</span></td>
						<td style="width: 40%;"><span
							class="resumen_item__detail">{{ this.prp.transfer_amount.amount }}</span></td>
					</tr>
				</table>

			</div>
		</div>
	</ng-container>
</ui-card-page>

